import { ColorEnum } from '@e-socna/data-layer';

export const colorToMuiColor = (color: ColorEnum) => {
  switch (color) {
    case ColorEnum.Default:
      return 'default';
    case ColorEnum.Primary:
      return 'primary';
    case ColorEnum.Secondary:
      return 'secondary';
    case ColorEnum.Error:
      return 'error';
    case ColorEnum.Info:
      return 'info';
    case ColorEnum.Success:
      return 'success';
    case ColorEnum.Warning:
      return 'warning';
    default:
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      throw new Error(`Unknown color: ${color}`);
  }
};
